import React, { useCallback, useEffect, useState } from "react";
import { HeaderComponent } from "../../../../components/header/header.component";
import { MenuList } from "../menu/menu";
import { useLocation, useNavigate } from "react-router-dom";
import { ModuleSection } from "../menu/type";
import { useQuery } from "../../../../utils/hooks/use-query";
import { fetchCandidateOnboardingForm, getAAJIRegistrationByCandidate } from "../../network/network";
import { useTranslation } from "react-i18next";
import { ONBOARDING_PATH, ROOT_PATH } from "../../../../routes/constants";
import { useSelector } from "react-redux";
import { selectCandidateOnboardingForm } from "../../redux/selector";

type MenuScreenProps = {};

export const ExamRegistrationPLAI = (props: MenuScreenProps) => {
    const { t, i18n } = useTranslation();
    const { state } = useLocation();
    const candidateOnboardingForm = useSelector(selectCandidateOnboardingForm);

    const [examRegist, setExamRegist] = useState({ aaji: false, aasi: false });
    const [dataExamRegist, setDataExamRegist] = useState({ aaji: false, aasi: false, step: 0 });
    const [appId, setAppId] = useState();
    const [registrationCandidateExam, setRegistrationCandidateExam] = useState({
        aaji: {
            aajiExamType: "",
            aajiExamLocation: "",
            aajiExamDate: "",
            aajiExamStartTime: "",
            aajiExamEndTime: "",
            aajiExamLocationName: "",
            aajiExamQuotaFilled: 0,
            aajiExamQuota: 0,
            aajiExamScheduleId: 0,
        },
        aasi: {
            aajiExamType: "",
            aajiExamLocation: "",
            aajiExamDate: "",
            aajiExamStartTime: "",
            aajiExamEndTime: "",
            aajiExamLocationName: "",
            aajiExamQuotaFilled: 0,
            aajiExamQuota: 0,
            aajiExamScheduleId: 0,
        },
    });
    const [data, setData] = useState<ModuleSection[] | undefined>(undefined);
    const navigate = useNavigate();
    const query = useQuery();
    const npaNumber = query.get("npaNumber") ?? "";
    const candidateId = query.get("candidateId") ?? "";

    const getExamRegistration = useCallback(async () => {
        if (npaNumber) {
            const dataCandidate = await fetchCandidateOnboardingForm(candidateId);
            const data = {
                aaji: dataCandidate?.data[0]?.examRegistration?.aaji,
                aasi: dataCandidate?.data[0]?.examRegistration?.aasi
            }
            const dataWithStep = {
                aaji: dataCandidate?.data[0]?.examRegistration?.aaji,
                aasi: dataCandidate?.data[0]?.examRegistration?.aasi,
                step: dataCandidate?.data[0]?.examRegistration?.step
            }

            const payload = {
                body: {
                    npaNumber: npaNumber,
                },
                access_token: "",
            };
            setExamRegist(data);
            setDataExamRegist(dataWithStep);
            setAppId(dataCandidate?.data[0]?.applicationId)

            const dataRegistration = await getAAJIRegistrationByCandidate(payload);
            const dataAAJI = dataRegistration.result
                .reverse()
                .find((el: { aajiExamType: string }) => el.aajiExamType === "F");
            const dataAASI = dataRegistration.result
                .reverse()
                .find((el: { aajiExamType: string }) => el.aajiExamType === "S");
            const joinData = {
                aaji: dataAAJI,
                aasi: dataAASI,
            };
            setRegistrationCandidateExam(joinData);
        }
    }, [examRegist]);

    useEffect(() => {
        let countExamRegist = 0;
        countExamRegist =
            (examRegist?.aaji == false || examRegist?.aaji == undefined ? 0 : 1) +
            (examRegist?.aasi == false || examRegist?.aasi == undefined ? 0 : 1);
        setData([
            {
                title: t("license_exam_registration"),
                name: "examregistrationPLAI",
                data: [
                    {
                        title: "AAJI",
                        name: "examRegistrationPLAIAAJI",
                        status: examRegist?.aaji == true ? "completed" : "untouched",
                        dataExamRegist: registrationCandidateExam.aaji,
                    },
                    {
                        title: "AASI",
                        name: "examRegistrationPLAIAASI",
                        status: examRegist?.aasi == true ? "completed" : "untouched",
                        dataExamRegist: registrationCandidateExam.aasi,
                    },
                ],
                numerator: countExamRegist,
                denominator: 2,
                status: countExamRegist == 2 ? "completed" : "untouched",
            },
        ]);
    }, [examRegist, registrationCandidateExam]);

    useEffect(() => {
        getExamRegistration();
    }, []);
    return (
        <div className="fixed overflow-hidden overscroll-y-none h-screen flex flex-col">
            <HeaderComponent
                title={t("license_exam_registration")}
                onBack={() => {
                    navigate(`${ROOT_PATH}/${ONBOARDING_PATH}?${query.toString()}`);
                }}
            />
            <div className={`w-screen flex flex-1 overflow-auto`}>
                <div className={`w-screen flex flex-1 flex-col`}>
                    <div className="flex-1 flex-col bg-gray-100">
                        <MenuList
                            sections={data}
                            npaNumber={npaNumber}
                            applicationStatus={candidateOnboardingForm?.applicationStatus}
                            applicationId={appId}
                            examRegistrationStatus={dataExamRegist}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
